import React from "react";
import {Box, Button, Paper, TextField, Typography} from "@mui/material";


export default function ServerSettingsForm({ settings, handleChange, openDialog }) {
    return (
        <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Основные параметры</Typography>

            <TextField fullWidth label="Название" value={settings.title} onChange={(e) => handleChange('title', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Описание" value={settings.description} onChange={(e) => handleChange('description', e.target.value)} sx={{ mb: 2 }} multiline />
            <TextField fullWidth label="Размер карты" value={settings.map_size} onChange={(e) => handleChange('map_size', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Максимум игроков" value={settings.max_players} onChange={(e) => handleChange('max_players', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="SEED карты" value={settings.seed} onChange={(e) => handleChange('seed', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Игровой порт" value={settings.game_port} onChange={(e) => handleChange('game_port', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="RCON порт" value={settings.rcon_port} onChange={(e) => handleChange('rcon_port', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="RCON пароль" value={settings.rcon_password} onChange={(e) => handleChange('rcon_password', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="IP адрес сервера" value={settings.address} onChange={(e) => handleChange('address', e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Картинка (ссылка)" value={settings.image_url} onChange={(e) => handleChange('image_url', e.target.value)} sx={{ mb: 2 }} />
            {settings.image_url && (
                <Box mt={2}>
                    <Typography variant="subtitle2">Предпросмотр картинки:</Typography>
                    <img src={settings.image_url} alt="Server Preview" style={{ maxWidth: "100%", maxHeight: 200, marginTop: 8, borderRadius: 8 }} />
                </Box>
            )}
            <Button variant="contained" color="primary" onClick={() => openDialog("save")} sx={{ mt: 2 }}>
                Сохранить изменения
            </Button>
        </Paper>
    );
}